import AxiosClient from "../../../services/axios.services";

class CollaboratorTypeServices {
  getCollaboratorType = (params) =>
    AxiosClient.get(
      "/api/app/notificacion_tipo_colaborador/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getCollaboratorTypeByID = (id) =>
    AxiosClient.get(
      `/api/app/notificacion_tipo_colaborador/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveCollaboratorType = (data) =>
    AxiosClient.post(
      "/api/app/notificacion_tipo_colaborador/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editCollaboratorType = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_tipo_colaborador/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deleteCollaboratorType = (id) =>
    AxiosClient.delete(
      `/api/app/notificacion_tipo_colaborador/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CollaboratorTypeServices();
